<template>
    <v-container >
      <v-layout align-center justify-center row>
      <image-input v-model="image" @input="updateAvatar">
        <div slot="activator">
          <v-avatar size="150px" v-ripple v-if="!imageSet" :tile="true" class="grey lighten-3 mb-3">
            <span>Click to Add a Picture</span>
          </v-avatar>
          <v-avatar size="150px" v-ripple :tile="true" v-else class="mb-3">
            <img :src="image.imageURL" alt="avatar">
          </v-avatar>
          <div v-if="errorMsg !== ''" class="v-messages theme-light error--text">
            {{ errorMsg }}
          </div>
        </div>
      </image-input>
      </v-layout>
    </v-container>
</template>


<script>
  import ImageInput from './imageinput.vue'
  export default {
    name: 'imageUploader',
    data () {
      return {
        saving: false,
        saved: false,
        imageSet: false,
        image: null
      }
    },
    components: {
      ImageInput: ImageInput
    },
    props: {
      constImage: null,
      dialog: '',
      errorMsg: ''
    },
    watch: {
      constImage (val) {
        if (val) {
          if (val.imageURL) {
            this.imageSet = true
            this.image = val
          }
        }
      },
      dialog (val) {
        if (!val) {
          this.imageSet = false
          this.image = null
        }
      }
    },
    methods: {
      updateAvatar (a) {
        this.image = a
        this.imageSet = true
        this.$emit('image', this.image)
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/assets/uploader/imageUploader.vue